import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetUser } from "../FirebaseQueries";
import { Stack, Card, Typography, Divider } from "@mui/material";
import { Timestamp } from "firebase/firestore";

interface UserInfo {
    fullName: string;
    role: string;
    email: string;
    lastActive: Timestamp | undefined;
}

export default function User() {
    let params = useParams();
    const [user, setUser] = useState<UserInfo>({
        fullName: "...",
        role: "...",
        email: "...",
        lastActive: undefined,
    });

    useEffect(() => {
        const userId: string = params.userId !== undefined ? params.userId : "";

        const FetchUser = async () => {
            const snapshot = await GetUser(userId);
            if (snapshot.exists()) {
                let newUser = {
                    fullName: snapshot.data().fullName,
                    role: snapshot.data().role,
                    email: snapshot.data().email,
                    lastActive: snapshot.data().lastActive,
                };
                setUser(newUser);
            }
        };

        if (userId !== "") FetchUser();
    }, []);

    return (
        <Stack spacing={2} sx={{ width: "100%" }}>
            <Card>
                <Typography variant="subtitle1" sx={{ textAlign: "left" }}>
                        User Information
                    </Typography>
                    <Divider />
                    <Stack spacing={0.5} sx={{ mt: 2 }}>
                        <Typography sx={{ textAlign: "left" }}>Name: {user.fullName}</Typography>
                        <Typography sx={{ textAlign: "left" }}>Role: {user.role}</Typography>
                        <Typography sx={{ textAlign: "left" }}>Email: {user.email}</Typography>
                        <Typography sx={{ textAlign: "left" }}>Last Online: {user.lastActive?.toDate().toDateString()}</Typography>
                    </Stack>
            </Card>
        </Stack>
    );
}
